import React from "react";
import { HiTableCells } from "react-icons/hi2";
import { BsFillPersonFill } from "react-icons/bs";
import { FaClipboardList } from "react-icons/fa";
import { LiaTableSolid } from "react-icons/lia";
import Links from "../sub-components/Links";
const { PUBLIC_URL } = process.env;

const Feature2 = () => {
  const dashboard_Video = process.env.REACT_APP_DASHBOARD_VIDEO;

  return (
    <div>
      <section className="section main-banner" id="f2top">
        <video autoPlay muted loop id="bg-video">
          <source
            src={dashboard_Video}
            type="video/mp4"
          />
        </video>

        <div className="video-overlay header-text">
          <div className="caption">
            <h4 style={{ color: "#f5a425" }}>
              All assessment results are <br />
              right at your fingertips
            </h4>
            <h6>
              Export and archive collected data. Access it
              <br />
              anywhere, anytime, and on any device.
            </h6>

            <div className="main-button">
              <div className="scroll-to-section">
                <a href={`${PUBLIC_URL}/#section3`}>Sign up - it's free</a>
              </div>
            </div>
            <br />
            {/* <div>
                <a style={{ fontSize: "16px", color: "white" }}>Learn more</a>
                <br />
                <GoArrowDown style={{ color: "white" }} />
              </div> */}
          </div>
        </div>
      </section>

      <section className="dark-bg">
        <div className="container-fluid dark-bg-sec">
          <div className="row f2sec1">
            <div className="col-lg-12 f2sec1head">
              <h2>7 convenient reporting options</h2>
              <h4>
                Make the most of your results with our online test builder’s
                advanced reporting features.
              </h4>
            </div>

            <div className="col-lg-12 f2sec1content">
              <div className="row">
                <div className="col-lg-6">
                  <h3>
                    <span>
                      <HiTableCells className="f2sec1icon" />
                    </span>{" "}
                    Results table
                  </h3>
                  <p>
                    All data is accessible instantly in the form of PDF, Excel,
                    and CSV files.
                  </p>
                </div>
                <div className="col-lg-6">
                  <h3>
                    <span>
                      <FaClipboardList className="f2sec1icon" />
                    </span>{" "}
                    Detailed results report
                  </h3>
                  <p>
                    Insightful data is put together in a convenient Excel file.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-12 f2sec1content">
              <div className="row">
                <div className="col-lg-6">
                  <h3>
                    <span>
                      <BsFillPersonFill className="f2sec1icon" />
                    </span>{" "}
                    Detailed respondent test sheet
                  </h3>
                  <p>
                    Access two varieties of the PDF file report that include all
                    the details of the assessment.
                  </p>
                </div>
                <div className="col-lg-6">
                  <h3>
                    <span>
                      <LiaTableSolid className="f2sec1icon" />
                    </span>{" "}
                    Answers matrix
                  </h3>
                  <p>
                    This Excel file which contains all the answers is a very
                    useful tool for self-analysis and statistics.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="light-bg">
        <div className="container-fluid light-bg-sec">
          <div className="row f2sec2">
            <div className="col-md-12 col-lg-6 f2sec2img">
              <article className="video-item ">
                <figure>
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/reporting-tp1.webp`}
                    alt=""
                  />
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_curve_top.svg`}
                    alt=""
                    className="green_curve_top"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_curve_bottom.svg`}
                    alt=""
                    className="green_curve_bottom"
                  />
                </figure>
              </article>
            </div>

            <div className="col-lg-6 f2sec2content">
              <h3>Compare various tests for deeper understanding</h3>
              <p>
                NexTestify allows access to information from various assessments
                stored in your databases. You can effortlessly compare test
                results to observe significant differences, patterns, and
                trends.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Links />
    </div>
  );
};

export default Feature2;
